import {
	RESET_STATE,
	SET_TRAILER_INFO,
	SET_LEGALS,
	SET_TRAILER_TYPES,
	SET_IS_TRAILER_DELETING,
	SET_IS_TRAILER_INFO_LOADING,
	SET_IS_TRAILER_SAVING,
	SET_IS_LEGALS_LOADING,
	SET_IS_TRAILER_TYPES_LOADING,
	SET_IS_MODES_LOADING,
	SET_IS_OWNERSHIPS_LOADING,
	SET_MODES,
	SET_OWNERSHIPS,
	SET_EVENT_DATA,
	SET_IS_EVENT_DATA_LOADING,
} from './actions';

export const initialState = {
	trailerInfo: null,
	isTrailerInfoLoading: false,
	isTrailerDeleting: false,
	isTrailerSaving: false,
	isTonnagesLoading: false,
	legals: [],
	isLegalsLoading: false,
	isTrailerTypesLoading: false,
	isModesLoading: false,
	ownerships: [],
	trailerTypes: [],
	modes: [],
	eventData: null,
	isEventDataLoading: false,
};

const trailersModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_TRAILER_INFO:
			return {
				...state,
				trailerInfo: payload,
			};
		case SET_IS_TRAILER_INFO_LOADING:
			return {
				...state,
				isTrailerInfoLoading: payload,
			};
		case SET_IS_TRAILER_DELETING:
			return {
				...state,
				isTrailerDeleting: payload,
			};
		case SET_IS_TRAILER_SAVING:
			return {
				...state,
				isTrailerSaving: payload,
			};
		case SET_OWNERSHIPS:
			return {
				...state,
				ownerships: payload,
			};
		case SET_IS_OWNERSHIPS_LOADING:
			return {
				...state,
				isTonnagesLoading: payload,
			};
		case SET_LEGALS:
			return {
				...state,
				legals: payload,
			};
		case SET_IS_LEGALS_LOADING:
			return {
				...state,
				isLegalsLoading: payload,
			};
		case SET_TRAILER_TYPES:
			return {
				...state,
				trailerTypes: payload,
			};
		case SET_IS_TRAILER_TYPES_LOADING:
			return {
				...state,
				isTrailerTypesLoading: payload,
			};
		case SET_MODES:
			return {
				...state,
				modes: payload,
			};
		case SET_IS_MODES_LOADING:
			return {
				...state,
				isModesLoading: payload,
			};
		case SET_EVENT_DATA:
			return {
				...state,
				eventData: payload,
			};
		case SET_IS_EVENT_DATA_LOADING:
			return {
				...state,
				isEventDataLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default trailersModalReducer;
